import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=e0db25fc&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=e0db25fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0db25fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0db25fc')) {
      api.createRecord('e0db25fc', component.options)
    } else {
      api.reload('e0db25fc', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=e0db25fc&scoped=true&", function () {
      api.rerender('e0db25fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2m5Ir3XrvhaBM/JS/comp/CookieBox.vue"
export default component.exports